import { Injectable } from '@angular/core';
import { ToastService } from '../../_services';
import { SuccessModalComponent } from '../../shared/success-modal/success-modal.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class SuccessModalHelperService {

  private _successModalShowing: boolean;
  private _toastPreferred: boolean;

  constructor(
    public dialog: MatDialog,
    private toast: ToastService
    ) {
      this._toastPreferred = false;
     }

  public show(message: string = ""): void {
    if (!this._toastPreferred) {
      if (!this._successModalShowing) {
        this._successModalShowing = true;

        const dialogRef = this.dialog.open(SuccessModalComponent, {
          panelClass: 'my-success-dialog',
          data: { message }
        });
        dialogRef.afterClosed().subscribe((confirm: boolean) => {
          this._successModalShowing = false;
        });
      }
    } else {
      this.toast.success(message);
    }
    
  }

}
